import Immutable, { List, Map } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import moment from 'moment'
import ActionHelper from 'helpers/action'
import ArrayHelper from 'helpers/array'

// constants
export const FETCH_FEED_AMOUNT_CHART_DATA =
  'slaMonitor/FETCH_FEED_AMOUNT_CHART_DATA'
export const FETCH_ACTUAL_EXPECTED_CHART_DATA =
  'slaMonitor/FETCH_ACTUAL_EXPECTED_CHART_DATA'
export const SET_FEED_AMOUNT_CHART_DATA =
  'slaMonitor/SET_FEED_AMOUNT_CHART_DATA'
export const SET_ACTUAL_EXPECTED_CHART_DATA =
  'slaMonitor/SET_ACTUAL_EXPECTED_CHART_DATA'
export const SET_DAYS_LEFT_FEEDING_CHART_DATA =
  'slaMonitor/SET_DAYS_LEFT_FEEDING_CHART_DATA'
export const FETCH_CAGES_LIST = 'slaMonitor/FETCH_CAGES_LIST'
export const SET_CAGES_LIST = 'slaMonitor/SET_CAGES_LIST'
export const RELOAD_CAGES_LIST = 'slaMonitor/RELOAD_CAGES_LIST'
export const FETCH_CAGES_RATE_LIST = 'slaMonitor/FETCH_CAGES_RATE_LIST'
export const SET_CAGES_RATE_LIST = 'slaMonitor/SET_CAGES_RATE_LIST'
export const FAILURE_CAGES_RATE_LIST = 'slaMonitor/FAILURE_CAGES_RATE_LIST'
export const FETCH_SITE_SENSORS = 'slaMonitor/FETCH_SITE_SENSORS'
export const SET_SITE_SENSORS = 'slaMonitor/SET_SITE_SENSORS'
export const OPEN_CAGE_DRAWER = 'slaMonitor/OPEN_CAGE_DRAWER'
export const OPEN_RATE_HISTORY = 'slaMonitor/OPEN_RATE_HISTORY'
export const FETCH_USER_LIST = 'slaMonitor/FETCH_USER_LIST'
export const SET_USER_LIST = 'slaMonitor/SET_USER_LIST'
export const SET_CAGE_RATE = 'slaMonitor/SET_CAGE_RATE'
export const SET_ACTIVE_DATE = 'slaMonitor/SET_ACTIVE_DATE'
export const SET_ACTIVE_CAGE = 'slaMonitor/SET_ACTIVE_CAGE'
export const RESET_SLA_STORE = 'slaMonitor/RESET_SLA_STORE'

// actions
export const fetchFeedAmountChartData = ActionHelper.createActionObj(
  FETCH_FEED_AMOUNT_CHART_DATA,
)
export const fetchActualExpectedChartData = ActionHelper.createActionObj(
  FETCH_ACTUAL_EXPECTED_CHART_DATA,
)
export const fetchCageList = ActionHelper.createActionObj(FETCH_CAGES_LIST)
export const reloadCageList = ActionHelper.createActionObj(RELOAD_CAGES_LIST)
export const fetchCageRateList = ActionHelper.createActionObj(
  FETCH_CAGES_RATE_LIST,
)
export const fetchUserList = ActionHelper.createActionObj(FETCH_USER_LIST)
export const fetchSiteSensor = ActionHelper.createActionObj(FETCH_SITE_SENSORS)
export const openCageDrawer = ActionHelper.createActionObj(OPEN_CAGE_DRAWER)
export const openRateHistory = ActionHelper.createActionObj(OPEN_RATE_HISTORY)
export const setCageRate = ActionHelper.createActionObj(SET_CAGE_RATE)
export const setActiveDate = ActionHelper.createActionObj(SET_ACTIVE_DATE)
export const setActiveCage = ActionHelper.createActionObj(SET_ACTIVE_CAGE)
export const resetSlaStore = ActionHelper.createActionObj(RESET_SLA_STORE)

// export const FETCH_SITE_TFA_DATA = 'slaMonitor/FETCH_SITE_TFA_DATA';
// export const SUCCESS_SITE_TFA_DATA = 'slaMonitor/SUCCESS_SITE_TFA_DATA';
// export const FAILURE_SITE_TFA_DATA = 'slaMonitor/FAILURE_SITE_TFA_DATA';
// export const FETCH_CAGE_TFA_DATA = 'slaMonitor/FETCH_CAGE_TFA_DATA';
// export const SUCCESS_CAGE_TFA_DATA = 'slaMonitor/SUCCESS_CAGE_TFA_DATA';
// export const FAILURE_CAGE_TFA_DATA = 'slaMonitor/FAILURE_CAGE_TFA_DATA';
// export const RESET_CAGE_TFA_DATA = 'slaMonitor/RESET_CAGE_TFA_DATA';
// export const fetchSiteTFAData = ActionHelper.createActionObj(FETCH_SITE_TFA_DATA);
// export const fetchCageTFAData = ActionHelper.createActionObj(FETCH_CAGE_TFA_DATA);
// export const resetCageTFAData = ActionHelper.createActionObj(RESET_CAGE_TFA_DATA);

export const FETCH_SITE_AVE_DATA = 'slaMonitor/FETCH_SITE_AVE_DATA'
export const SUCCESS_SITE_AVE_DATA = 'slaMonitor/SUCCESS_SITE_AVE_DATA'
export const FAILURE_SITE_AVE_DATA = 'slaMonitor/FAILURE_SITE_AVE_DATA'
export const FETCH_CAGE_AVE_DATA = 'slaMonitor/FETCH_CAGE_AVE_DATA'
export const SUCCESS_CAGE_AVE_DATA = 'slaMonitor/SUCCESS_CAGE_AVE_DATA'
export const FAILURE_CAGE_AVE_DATA = 'slaMonitor/FAILURE_CAGE_AVE_DATA'
export const RESET_CAGE_AVE_DATA = 'slaMonitor/RESET_CAGE_AVE_DATA'
export const fetchSiteAvEData = ActionHelper.createActionObj(
  FETCH_SITE_AVE_DATA,
)
export const fetchCageAvEData = ActionHelper.createActionObj(
  FETCH_CAGE_AVE_DATA,
)
export const resetCageAVEData = ActionHelper.createActionObj(
  RESET_CAGE_AVE_DATA,
)

export const FETCH_SITE_SFR_DATA = 'slaMonitor/FETCH_SITE_SFR_DATA'
export const SUCCESS_SITE_SFR_DATA = 'slaMonitor/SUCCESS_SITE_SFR_DATA'
export const FAILURE_SITE_SFR_DATA = 'slaMonitor/FAILURE_SITE_SFR_DATA'
export const FETCH_CAGE_SFR_DATA = 'slaMonitor/FETCH_CAGE_SFR_DATA'
export const SUCCESS_CAGE_SFR_DATA = 'slaMonitor/SUCCESS_CAGE_SFR_DATA'
export const FAILURE_CAGE_SFR_DATA = 'slaMonitor/FAILURE_CAGE_SFR_DATA'
export const RESET_CAGE_SFR_DATA = 'slaMonitor/RESET_CAGE_SFR_DATA'
export const fetchSiteSFRData = ActionHelper.createActionObj(
  FETCH_SITE_SFR_DATA,
)
export const fetchCageSFRData = ActionHelper.createActionObj(
  FETCH_CAGE_SFR_DATA,
)
export const resetCageSFRData = ActionHelper.createActionObj(
  RESET_CAGE_SFR_DATA,
)

export const FETCH_SITE_DLF_DATA = 'slaMonitor/FETCH_SITE_DLF_DATA'
export const SUCCESS_SITE_DLF_DATA = 'slaMonitor/SUCCESS_SITE_DLF_DATA'
export const FAILURE_SITE_DLF_DATA = 'slaMonitor/FAILURE_SITE_DLF_DATA'
export const FETCH_SILO_DLF_DATA = 'slaMonitor/FETCH_SILO_DLF_DATA'
export const SUCCESS_SILO_DLF_DATA = 'slaMonitor/SUCCESS_SILO_DLF_DATA'
export const FAILURE_SILO_DLF_DATA = 'slaMonitor/FAILURE_SILO_DLF_DATA'
export const RESET_SILO_DLF_DATA = 'slaMonitor/RESET_SILO_DLF_DATA'
export const fetchSiteDLFData = ActionHelper.createActionObj(
  FETCH_SITE_DLF_DATA,
)
export const fetchSiloDLFData = ActionHelper.createActionObj(
  FETCH_SILO_DLF_DATA,
)
export const resetSiloDLFData = ActionHelper.createActionObj(
  RESET_SILO_DLF_DATA,
)

const initialState = Immutable.fromJS({
  isOpenRateHistory: false,
  isReloadCageList: false,
  siteSensors: {},
  activeDate: moment.utc(),
  activeCage: 0,
  cageList: [],
  cageRateListData: {
    cageRateList: [],
    loader: false,
  },
  activeDrawerCage: {
    id: null,
    specie: '',
  },
  userList: [],
  amountFeedChart: {},
  actualExpectedChart: [],
  daysLeftFeedingChart: [],
  siteAVELoader: true,
  cageAVELoader: true,
  siteSFRLoader: true,
  cageSFRLoader: true,
  siteDLFLoader: true,
  siloDLFLoader: true,

  // siteTFAData: Map({
  //     total_feed_used: 0,
  //     total_feed_visit: 0,
  //     avg_duration: "00:00:00",
  //     locus: [],
  //     loader: true,
  // }),
  // cageTFAData: Map({
  //     locus_id: 0,
  //     locus_name: "N/A",
  //     total_feed_used: 0,
  //     total_feed_visit: 0,
  //     avg_duration: "00:00:00",
  //     data: [],
  //     loader: true,
  // }),
  siteAvEData: Map({
    last_updated: null,
    total_difference: 0,
    total_feed_expected: 0,
    total_feed_used: 0,
    locus: [],
  }),
  cageAvEData: Map({
    last_updated: null,
    locus_id: 0,
    locus_name: 'N/A',
    difference: 0,
    feed_expected: 0,
    feed_used: 0,
    data: [],
  }),
  siteSFRData: Map({
    last_updated: null,
    sfr_observed: 0,
    sfr_expected: 0,
    sfr_corrected: 0,
    locus: [],
  }),
  cageSFRData: Map({
    last_updated: null,
    locus_id: 0,
    locus_name: 'N/A',
    sfr_observed: 0,
    sfr_expected: 0,
    sfr_corrected: 0,
    data: [],
  }),
  siteDLFData: Map({
    last_updated: null,
    remaining_feed: 0,
    avg_daily_feeding: 0,
    days_left: 0,
    data: [],
  }),
  siloDLFData: Map({
    last_updated: null,
    silo_id: 0,
    silo_title: 'N/A',
    remaining_feed: 0,
    avg_daily_feeding: 0,
    days_left: 0,
    dates: [],
    cages: [],
    data: [],
  }),
})

const slaMonitor = handleActions(
  {
    [SET_FEED_AMOUNT_CHART_DATA]: (state, action) =>
      state.set('amountFeedChart', Map(action.payload)),
    [SET_ACTUAL_EXPECTED_CHART_DATA]: (state, action) =>
      state.set('actualExpectedChart', List(action.payload.data)),
    [SET_DAYS_LEFT_FEEDING_CHART_DATA]: (state, action) =>
      state.set('daysLeftFeedingChart', List(action.payload.data)),
    [RESET_SLA_STORE]: state =>
      state
        .set('amountFeedChart', Map({}))
        .set('actualExpectedChart', List([]))
        .set('daysLeftFeedingChart', List([]))
        .set('sfrChart', List([])),
    [SET_CAGES_LIST]: (state, action) =>
      state
        .set('cageList', List(action.payload.list))
        .set('isReloadCageList', false),
    [FETCH_CAGES_RATE_LIST]: state =>
      state.setIn(['cageRateListData', 'loader'], true),
    [SET_CAGES_RATE_LIST]: (state, action) =>
      state
        .setIn(['cageRateListData', 'cageRateList'], List(action.payload.list))
        .setIn(['cageRateListData', 'loader'], false),
    [FAILURE_CAGES_RATE_LIST]: state =>
      state
        .setIn(['cageRateListData', 'cageRateList'], [])
        .setIn(['cageRateListData', 'loader'], false),
    [SET_ACTIVE_CAGE]: (state, action) =>
      state.set('activeCage', action.payload),
    [SET_USER_LIST]: (state, action) =>
      state.set('userList', List(action.payload.list)),
    [OPEN_CAGE_DRAWER]: (state, action) =>
      state.set('activeDrawerCage', Map(action.payload)),
    [OPEN_RATE_HISTORY]: (state, action) =>
      state.set('isOpenRateHistory', action.payload),
    [SET_ACTIVE_DATE]: (state, action) =>
      state.set('activeDate', action.payload),
    [SET_ACTIVE_CAGE]: (state, action) =>
      state.set('activeCage', action.payload),
    [SET_SITE_SENSORS]: (state, action) =>
      state.set(
        'siteSensors',
        Map(ArrayHelper.map(action.payload.list, 'type_name')),
      ),
    [RELOAD_CAGES_LIST]: (state, action) =>
      state.set('isReloadCageList', action.payload),

    // NEW REDUCER
    // [FETCH_SITE_TFA_DATA]: (state) => {
    //     return state.setIn(['siteTFAData', 'loader'], true);
    // },
    // [SUCCESS_SITE_TFA_DATA]: (state, action) => {
    //     return state
    //         .set('siteTFAData', Map(action.payload))
    //         .setIn(['siteTFAData', 'loader'], false);
    // },
    // [FAILURE_SITE_TFA_DATA]: (state) => {
    //     return state
    //         .set('siteTFAData', initialState.get('siteTFAData'))
    //         .setIn(['siteTFAData', 'loader'], false);
    // },
    // [FETCH_CAGE_TFA_DATA]: (state) => {
    //     return state.setIn(['cageTFAData', 'loader'], true);
    // },
    // [SUCCESS_CAGE_TFA_DATA]: (state, action) => {
    //     return state
    //         .set('cageTFAData', Map(action.payload))
    //         .setIn(['cageTFAData', 'loader'], false);
    // },
    // [combineActions(FAILURE_CAGE_TFA_DATA, RESET_CAGE_TFA_DATA)]: (state) => {
    //     return state
    //         .set('cageTFAData', initialState.get('cageTFAData'))
    //         .setIn(['cageTFAData', 'loader'], false);
    // },

    [FETCH_SITE_AVE_DATA]: state => state.set('siteAVELoader', true),
    [SUCCESS_SITE_AVE_DATA]: (state, action) =>
      state.set('siteAvEData', Map(action.payload)).set('siteAVELoader', false),
    [FAILURE_SITE_AVE_DATA]: state =>
      state
        .set('siteAvEData', initialState.get('siteAvEData'))
        .set('siteAVELoader', false),
    [FETCH_CAGE_AVE_DATA]: state => state.set('cageAVELoader', true),
    [SUCCESS_CAGE_AVE_DATA]: (state, action) =>
      state.set('cageAvEData', Map(action.payload)).set('cageAVELoader', false),
    [combineActions(FAILURE_CAGE_AVE_DATA, RESET_CAGE_AVE_DATA)]: state =>
      state
        .set('cageAvEData', initialState.get('cageAvEData'))
        .set('cageAVELoader', false),

    [FETCH_SITE_SFR_DATA]: state => state.set('siteSFRLoader', true),
    [SUCCESS_SITE_SFR_DATA]: (state, action) =>
      state.set('siteSFRData', Map(action.payload)).set('siteSFRLoader', false),
    [FAILURE_SITE_SFR_DATA]: state =>
      state
        .set('siteSFRData', initialState.get('siteSFRData'))
        .set('siteSFRLoader', false),
    [FETCH_CAGE_SFR_DATA]: state => state.set('cageSFRLoader', true),
    [SUCCESS_CAGE_SFR_DATA]: (state, action) =>
      state.set('cageSFRData', Map(action.payload)).set('cageSFRLoader', false),
    [combineActions(FAILURE_CAGE_SFR_DATA, RESET_CAGE_SFR_DATA)]: state =>
      state
        .set('cageSFRData', initialState.get('cageSFRData'))
        .set('cageSFRLoader', false),

    [FETCH_SITE_DLF_DATA]: state => state.set('siteDLFLoader', true),
    [SUCCESS_SITE_DLF_DATA]: (state, action) =>
      state.set('siteDLFData', Map(action.payload)).set('siteDLFLoader', false),
    [FAILURE_SITE_DLF_DATA]: state =>
      state
        .set('siteDLFData', initialState.get('siteDLFData'))
        .set('siteDLFLoader', false),
    [FETCH_SILO_DLF_DATA]: state => state.set('siloDLFLoader', true),
    [SUCCESS_SILO_DLF_DATA]: (state, action) =>
      state.set('siloDLFData', Map(action.payload)).set('siloDLFLoader', false),
    [combineActions(FAILURE_SILO_DLF_DATA, RESET_SILO_DLF_DATA)]: state =>
      state
        .set('siloDLFData', initialState.get('siloDLFData'))
        .set('siloDLFLoader', false),
  },
  initialState,
)

export default slaMonitor
